import {take, call, put, select} from 'redux-saga/effects'
import {intToHexString} from '../utils'

import {
  SENDING_STATIONS_REQUEST,
  FETCH_STATIONS_REQUEST,
  FETCH_STATIONS_SUCCESS,
  FETCH_STATIONS_FAILURE,
  SENDING_STATION_UPDATE,
  UPDATE_STATION_REQUEST,
  //UPDATE_STATION_SUCCESS,
  UPDATE_STATION_FAILURE,
  SENDING_STATION_DELETE,
  DELETE_STATION_REQUEST,
  //DELETE_STATION_SUCCESS,
  DELETE_STATION_FAILURE,
  FETCH_ACCOUNTS_REQUEST
} from '../actions/constants'
import station from '../api/station'
import {putNotify} from './utils'

const getTokenFromState = (state) => state.user.currentUser.token;
const getSystemIDFromState = (state) => state.system.currentSystem.ID;

function* fetchStations({token, systemID, offset, limit}) {
  yield put({type: SENDING_STATIONS_REQUEST, sending: true})
  try {
    return yield call(station.fetchStations, token, systemID, offset, limit)
  } catch (error) {
    yield put({type: FETCH_STATIONS_FAILURE, error: error.message})
    return error
  } finally {
    yield put({type: SENDING_STATIONS_REQUEST, sending: false})
  }
}

export function* watchFetchStations() {
  while (true) {
    const {offset, limit} = yield take([FETCH_STATIONS_REQUEST, FETCH_ACCOUNTS_REQUEST])
    const token = yield select(getTokenFromState);
    const systemID = yield select(getSystemIDFromState);
    const response = yield call(fetchStations, {token, systemID, offset, limit})
    const arr = yield call(putNotify, {response})
    const stations = Array.isArray(arr)
      ? arr
      : []
    const hardwareIDHexStations = stations.map((station) => {
      return {
        ...station,
        HardwareIDHex: intToHexString(station.HardwareID)
      }
    })
    yield put({type: FETCH_STATIONS_SUCCESS, stations: hardwareIDHexStations});
  }
}

function* updateStation({token, systemID, updateStationState}) {
  yield put({type: SENDING_STATION_UPDATE, sending: true})
  try {
    return yield call(station.updateStation, token, systemID, updateStationState)
  } catch (error) {
    yield put({type: UPDATE_STATION_FAILURE, error: error.message})
    return error
  } finally {
    yield put({type: SENDING_STATION_UPDATE, sending: false})
  }
}

export function* watchUpdateStationRequest() {
  while (true) {
    const {updateStationState} = yield take(UPDATE_STATION_REQUEST)
    const token = yield select(getTokenFromState);
    const systemID = yield select(getSystemIDFromState);
    const response = yield call(updateStation, {token, systemID, updateStationState})
    const notify = `Cập nhật thông tin trạm [${updateStationState.Name}] thành công!`
    yield call(putNotify, {response, notify})
    yield put({type: FETCH_STATIONS_REQUEST});
  }
}

function* deleteStation({token, systemID, deleteStationState}) {
  yield put({type: SENDING_STATION_DELETE, sending: true})
  try {
    return yield call(station.deleteStation, token, systemID, deleteStationState)
  } catch (error) {
    yield put({type: DELETE_STATION_FAILURE, error: error.message})
    return error
  } finally {
    yield put({type: SENDING_STATION_DELETE, sending: false})
  }
}

export function* watchDeleteStationRequest() {
  while (true) {
    const {deleteStationState} = yield take(DELETE_STATION_REQUEST)
    const token = yield select(getTokenFromState);
    const systemID = yield select(getSystemIDFromState);
    const response = yield call(deleteStation, {token, systemID, deleteStationState})
    const notify = `Xoá trạm [${deleteStationState.Name}] thành công!`
    yield call(putNotify, {response, notify})
    yield put({type: FETCH_STATIONS_REQUEST});
  }
}



// WEBPACK FOOTER //
// ./src/sagas/stations.js